import { z } from 'zod'

import { DISTRICT_MANAGER_LEVEL } from '@/constants/pos-user-levels'

import { requiredError } from './shared'

export const posUserFormSchema = z
  .object({
    id: z.coerce.number<number>().int().min(1, 'ID is required and must be a positive integer'),
    first_name: z.string().min(1, 'First name is required').max(100, 'First name is too long'),
    last_name: z.string().min(1, 'Last name is required').max(100, 'Last name is too long'),
    email: z.email('Invalid email address').or(z.literal('')).optional(),
    level: z.coerce.number<number>().int().min(0, 'Level is required'),
    pin: z.preprocess(
      (val) => (val === '' || val === undefined ? undefined : Number(val)),
      z.number(requiredError('PIN is required')).int().min(0, 'PIN must be 0 or greater')
    ),
    location_id: z.string().optional(),
    district_id: z.string().optional(),
    active: z.boolean(),
    expires: z.string().optional(),
    expires_eos: z.boolean(),
  })
  .superRefine((data, ctx) => {
    if (data.level < DISTRICT_MANAGER_LEVEL && !data.location_id) {
      ctx.addIssue({
        code: 'custom',
        message: 'Location is required',
        path: ['location_id'],
      })
    }
    if (data.level === DISTRICT_MANAGER_LEVEL && !data.district_id) {
      ctx.addIssue({
        code: 'custom',
        message: 'District is required',
        path: ['district_id'],
      })
    }
  })

export type PosUserFormData = z.infer<typeof posUserFormSchema>
export type PosUserFormInput = z.input<typeof posUserFormSchema>
